import CasingAndInterval from './CasingAndInterval';

export default CasingAndInterval;



// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/HoleGeometry/CasingAndInterval/index.tsx